"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var TextBold = function TextBold(_ref) {
  var className = _ref.className,
      children = _ref.children,
      color = _ref.color,
      otherProps = _objectWithoutProperties(_ref, ["className", "children", "color"]);

  return /*#__PURE__*/_react.default.createElement(P, _extends({
    color: color,
    className: className
  }, otherProps), children);
};

var P = _styledComponents.default.p.withConfig({
  displayName: "P"
})(["font-family:", ";font-size:1.6rem;font-weight:500;line-height:130%;color:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.font;
}, function (_ref3) {
  var color = _ref3.color,
      theme = _ref3.theme;
  return color ? color : theme.typo.title;
});

TextBold.propTypes = {
  /** Beeing able to use it in Styled Components */
  className: _propTypes.string,

  /** If true button is disabled */
  children: _propTypes.node.isRequired,
  color: _propTypes.string,
  otherProps: _propTypes.object
};
var _default = TextBold;
exports.default = _default;